export default __webpack_public_path__ + "static/media/NHL-live-footer.a0c5c623.png";